import { render } from "./NotificationCreate.vue?vue&type=template&id=b9bdb89a"
import script from "./NotificationCreate.vue?vue&type=script&lang=js"
export * from "./NotificationCreate.vue?vue&type=script&lang=js"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__